import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isNoindexPath } from "@/lib/seo/routeIndexing";

/**
 * Red de seguridad global: las rutas internas o de embudo reciben noindex
 * aunque la página olvide declararlo. Una página puede sobreescribirlo con
 * su propio <Helmet> (el más profundo gana), p. ej. los menús públicos.
 */
export function RouteRobots() {
  const { pathname } = useLocation();
  if (!isNoindexPath(pathname)) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex,follow" />
    </Helmet>
  );
}

export default RouteRobots;
